import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ca-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  private _fullName;

  @HostBinding('class.border')
  @Input()
  border: boolean = false;
  @Input()
  initials: '';
  @Input()
  set fullName(data) {
    this._fullName = data;
    if (!data) {
      this.initials = '';
    } else {
      this.initials = data
        .split(' ')
        .map((name) => name.charAt(0))
        .join('');
    }
  }
  get fullName() {
    // Allows for testability in other components
    return this._fullName;
  }

  @Input()
  background: boolean;
  @Input()
  image: string;

  @Input()
  blur: string;

  @Input()
  small: boolean;

  @Input()
  chip: boolean;

  @Input() fontSize?: number;
}
